import { http } from "@/http";

export default {
  getMaxProductImages() {
    return http.get("/api/v1/admin/plan/max-product-images");
  }
};